import styled from 'styled-components'

const AbsoluteFill = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`

export default AbsoluteFill
